import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PitchBreakdownFilter } from 'yankees-react-utils';

const StyledWrapper = styled.div`
    margin-top: 12px;
    text-align: left;
    && > div {
        border: 1px solid rgb(188, 200, 209) !important;
        background-color: white;
    }
`;

const Filters = ({ filter, setFilter, isSwitch }) => (
    <StyledWrapper>
        <PitchBreakdownFilter
            filter={filter}
            setFilter={setFilter}
            availableResultTypes={new Set([1, 2, 3, 4, 5, 6, 7, 8])}
            showPitcherHand
            hideBatterHand
            hideAllPitcherHandOptions
            hidePitcherRole
            isSwitch={isSwitch}
        />
    </StyledWrapper>
);

Filters.propTypes = {
    filter: PropTypes.shape({}).isRequired,
    setFilter: PropTypes.func.isRequired,
    isSwitch: PropTypes.bool.isRequired,
};

export default Filters;
